import { PersonAddOutlined } from '@mui/icons-material';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import { useModal } from '../../contexts/ModalContext';
import FormModal from '../modals/FormModal';

const styles = {
  page: {
    width: '100%',
    maxWidth: 960,
  },
  card: {
    p: { xs: 2, md: 3 },
    borderRadius: 2,
  },
  content: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' },
    gap: { xs: 2, md: 3 },
    alignItems: { xs: 'flex-start', md: 'center' },
  },
  action: {
    minWidth: 180,
  },
};

const SuperAdminAccountsPage = () => {
  const { openModal } = useModal();

  const openCreateAccountModal = () => {
    openModal(<FormModal form='super-admin-account' />);
  };

  return (
    <Stack sx={styles.page}>
      <Paper elevation={0} sx={styles.card}>
        <Box sx={styles.content}>
          <Stack spacing={0.75}>
            <Typography variant='h5'>Super Admin Accounts</Typography>
            <Typography
              variant='body2'
              sx={{
                color: 'text.secondary',
              }}
            >
              Create a global Super Administrator identity. The account is not tied to the selected marketplace.
            </Typography>
          </Stack>
          <Button
            variant='contained'
            startIcon={<PersonAddOutlined />}
            onClick={openCreateAccountModal}
            sx={styles.action}
          >
            Create super admin
          </Button>
        </Box>
      </Paper>
    </Stack>
  );
};

export default SuperAdminAccountsPage;
